<template>
  <div>
    <m-table
      ref="table"
      :page-model="pageModel"
      resource="管理员"
      title="管理员中心"
      title-key="username"
      :rules="rules"
      border
    >
      <template v-slot:default>
        <el-table-column type="index" label="序" align="center" header-align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="150" align="center" header-align="center"></el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
          width="150"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column prop="gender" label="性别" width="100" align="center" header-align="center">
          <template slot-scope="{row}">
            <span v-if="row.gender === 0">保密</span>
            <span v-if="row.gender === 1">男</span>
            <span v-if="row.gender === 2">女</span>
          </template>
        </el-table-column>
        <el-table-column label="发送消息">
          <template slot-scope="{row}">
            <el-input v-model="row.msg" placeholder="请输入您要发送的内容" clearable>
              <template slot="append">
                <el-button type="primary" @click="sendMsg(row.id,row.msg)" :disabled="!row.msg">发送</el-button>
              </template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" header-align="center">
          <template slot-scope="{row}">
            <el-button
              type="success"
              size="small"
              icon="el-icon-edit"
              @click="$refs.table.openDia(row)"
            >修改</el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="$refs.table.del(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </template>
      <template v-slot:search>
        <el-form :model="condition" ref="search">
          <el-row :gutter="5">
            <el-col :span="4">
              <el-form-item prop="username">
                <el-input v-model="condition.username" placeholder="过滤用户名" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="mobile">
                <el-input v-model="condition.mobile" placeholder="过滤手机号" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="$refs.table.confirmSearch(condition)"
              ></el-button>
              <el-button icon="el-icon-refresh" @click="$refs.search.resetFields()"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template v-slot:form="{data}">
        <m-form :data="data" />
      </template>
    </m-table>
  </div>
</template>

<script>
import Manager from "../../models/Manager";
import MTable from "../../components/table/index";
import MForm from "./components/managerForm";
export default {
  components: { MTable, MForm },
  data: () => ({
    pageModel: new Manager(),
    rules: {
      username: [{ required: true, messsage: "请输入用户名", trigger: "blur" }],
      mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }]
    },
    condition: {
      username: null,
      mobile: null
    }
  }),
  methods: {
    sendMsg(id, msg) {
      if (!!msg) {
        let _this = this;
        this.pageModel
          .sendMsg(id, `[${this.$store.getters.user.username}]:` + msg)
          .then(res => {
            _this.$message({
              type: "success",
              message: "发送成功"
            });
          })
          .catch(e => {
            _this.$message({
              type: "error",
              message: e
            });
          });
      }
    }
  }
};
</script>

<style>
</style>